module.exports = __webpack_public_path__ + "img/gh-12132pin2.prt.cc6028ec.jpg";